import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const Details = styled.div`
    padding: 24px;
    border: 1px solid #5B5B5F66;
    border-radius: 8px;
    margin: 0 0 32px 0;
`;

export const DepList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;

    & .key {
        font-size: ${theme.font.size14};
        color: #5B5B5F;
    }

    & span {
        font-size: ${theme.font.size16};
        color: ${(props) => props.theme.black};
    }
`;
